import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import _map from 'lodash/map';
import PropTypes from 'prop-types';
// HOCs
import withFormManagement from 'hocs/WithFormManagement';
// Models
import {
  listFeatures,
  name,
} from 'models/cpm/carpark';
// Custom
import { fullListShape } from 'constants/PropTypesShapes';
import SubListTemplate from 'components/templates/SubListTemplate';
import CarparkRow from 'cpmCarparks/assets/main/CarparkRow';
import { buildListSpecs } from 'utils/Tools';
import CarparkFilters from 'cpmCarparks/assets/main/CarparkFilters';

class CarparkChooseList extends React.Component {
  constructor(props) {
    super(props);

    this.handleValidate = this.handleValidate.bind(this);
    this.handleSelectCarparks = this.handleSelectCarparks.bind(this);
    this.doGetRowComp = this.doGetRowComp.bind(this);

    // Build list specs: permanent filters
    const { permanentFiltersSpecs } = this.props;
    this.listSpecs = buildListSpecs(
      listFeatures.searchFields,
      permanentFiltersSpecs,
    );
  }

  componentDidMount() {
    // We need to pass component reference to parent (= DialogItem)
    const { onRef } = this.props;
    onRef(this);
  }

  // Handlers called by parent (= DialogItem)
  handleValidate() {
    const {
      fields: { selectedCarparks },
      onValidate,
    } = this.props;

    let selectedCarparkIds = [];
    if (selectedCarparks) {
      selectedCarparkIds = _map(selectedCarparks, 'id');
    }

    onValidate(selectedCarparkIds);
  }

  handleSelectCarparks(selectedCarparks) {
    const { onFieldsChange } = this.props;
    onFieldsChange({ selectedCarparks });
  }

  // Private
  doGetRowComp(props) {
    return <CarparkRow {...props} />;
  }

  render() {
    const {
      carparksList,
      enableSelection,
      fields: { selectedCarparks },
      handleListCarparks,
    } = this.props;
    const { excludedFilterFields, permanentFilters } = this.listSpecs;

    return (
      <div className="px-3 pb-4">
        {/* Bottom padding of 4 to match top padding of SubListTemplate */}
        <SubListTemplate
          withQueryParams={false}
          name={name}
          listFeatures={listFeatures}
          withSelection={enableSelection}
          multiSelectable={enableSelection}
          onSelectElements={this.handleSelectCarparks}
          elementsData={{
            loading: carparksList.loading,
            selectedElements: selectedCarparks,
            elements: carparksList.elements,
            handleGetList: handleListCarparks,
          }}
          permanentFilters={permanentFilters}
          excludedFilterFields={excludedFilterFields}
          filtersComp={(
            <CarparkFilters noPadding />
          )}
          rowComp={this.doGetRowComp}
        />
      </div>
    );
  }
}

CarparkChooseList.propTypes = {
  fields: PropTypes.object.isRequired,
  permanentFiltersSpecs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    }),
  ),
  carparksList: fullListShape.isRequired,
  carparksListAction: PropTypes.func.isRequired,
  carparksListStateGetter: PropTypes.func.isRequired,
  enableSelection: PropTypes.bool,
  handleListCarparks: PropTypes.func.isRequired,
  onFieldsChange: PropTypes.func.isRequired,
  onRef: PropTypes.func.isRequired,
  onValidate: PropTypes.func,
};

CarparkChooseList.defaultProps = {
  enableSelection: true,
  permanentFiltersSpecs: null,
  onValidate: null,
};

const mapFieldsToProps = {
  selectedCarparks: {
    defaultValue: [],
  },
};

const mapStateToProps = (state, ownProps) => {
  const { carparksListStateGetter } = ownProps;

  return { carparksList: carparksListStateGetter(state) };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { carparksListAction } = ownProps;

  return {
    handleListCarparks: (pagination, sort, filters) => {
      dispatch(carparksListAction(pagination, sort, filters));
    },
  };
};

module.exports = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withFormManagement(mapFieldsToProps, null, false),
)(CarparkChooseList);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/main/CarparkChooseList.js